import { combineReducers } from "redux";
import products from "./products";
import auth from "./auth";
import users from "./users";
import orders from "./orders";
import totalIncome from "./totalincome";
import categories from "./categories";
import store from "./store";
import stores from "./stores";
import shipping from "./shipping";
import storeInfo from "./storeinfo";
export default combineReducers({
  products,
  auth,
  users,
  totalIncome,
  orders,
  categories,
  store,
  stores,
  shipping,
  storeInfo,
});
